
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.13 7.13H8.87V2.87a.87.87 0 00-1.74 0v4.26H2.87a.87.87 0 100 1.74h4.26v4.26a.87.87 0 101.74 0V8.87h4.26a.87.87 0 000-1.74z"}})])
          )
        }
      }
    